import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";

import ReselifyLogo from "../../assets/images/reselifylogo.png";

const Header = ({ setTotalRemit }) => {
  const remitPercentage = 0;
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState("cosmic");

  const user = useSelector((state) => state.user);
  const estore = useSelector((state) => state.estore);

  useEffect(() => {
    gettingNotRemitSum();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const checkExpiredBills = (bills) => {
    const now = new Date();
    return bills.filter((bill) => new Date(bill.billDeadline) < now);
  };

  const gettingNotRemitSum = async () => {
    const result = await axios.get(
      process.env.REACT_APP_RESELL_API + "/gratis/get-not-remitted",
      {
        headers: {
          authToken: user.token,
          estoreid: estore._id,
        },
      }
    );
    if (result.data.err) {
      toast.error(result.data.err);
    } else {
      const bills = result.data || [];
      const total = bills.reduce(
        (a, b) =>
          a +
          (b.packageType === "dedicated"
            ? 25990
            : b.packageType === "single"
            ? 18990
            : b.totalAmount * remitPercentage),
        0
      );
      const expiredBills = checkExpiredBills(bills);
      // setTotalRemit({ total, overdue: expiredBills.length > 0 });
      setTotalRemit({ total, overdue: false });
    }
  };

  const handleMenuClick = (menu) => {
    setActiveMenu(menu);
    // Store the selected menu in localStorage for MainMenu to access
    localStorage.setItem("selectedProduct", menu);

    // Dispatch custom event for same-tab updates
    window.dispatchEvent(new CustomEvent("productChanged", { detail: menu }));

    // Add navigation logic here based on selected menu
    if (menu === "cosmic") {
      console.log("Navigating to Cosmic");
      // navigate("/cosmic");
    } else if (menu === "ingreventory") {
      console.log("Navigating to Ingreventory");
      // navigate("/ingreventory");
    }
  };

  const menuStyle = {
    mainContainer: {
      backgroundColor: "#009A57",
      width: "100%",
      color: "#ffffff",
      fontSize: 24,
      position: "fixed",
      zIndex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      height: "60px",
      padding: isMobile ? "0 10px" : "0 20px",
    },
    leftSection: {
      display: "flex",
      alignItems: "center",
      gap: isMobile ? "10px" : "20px",
    },
    menuContainer: {
      display: "flex",
      gap: isMobile ? "5px" : "15px",
    },
    menuItem: {
      padding: isMobile ? "5px 8px" : "8px 16px",
      cursor: "pointer",
      borderRadius: "4px",
      fontSize: isMobile ? "12px" : "16px",
      fontWeight: "500",
      transition: "all 0.3s ease",
      border: "1px solid transparent",
    },
    activeMenuItem: {
      backgroundColor: "#007A47",
      border: "1px solid #ffffff",
    },
    inactiveMenuItem: {
      backgroundColor: "transparent",
      border: "1px solid rgba(255, 255, 255, 0.3)",
    },
    rightSection: {
      display: "flex",
      alignItems: "center",
    },
  };

  return (
    <div style={menuStyle.mainContainer}>
      <div style={menuStyle.leftSection}>
        <img
          alt="Reselify"
          src={ReselifyLogo}
          width={isMobile ? 120 : 180}
          style={{
            cursor: "pointer",
          }}
          onClick={() => navigate("/")}
        />

        {estore._id === process.env.REACT_APP_MASTERID && user._id && (
          <div style={menuStyle.menuContainer}>
            <div
              style={{
                ...menuStyle.menuItem,
                ...(activeMenu === "cosmic"
                  ? menuStyle.activeMenuItem
                  : menuStyle.inactiveMenuItem),
              }}
              onClick={() => handleMenuClick("cosmic")}
            >
              Cosmic
            </div>
            <div
              style={{
                ...menuStyle.menuItem,
                ...(activeMenu === "ingreventory"
                  ? menuStyle.activeMenuItem
                  : menuStyle.inactiveMenuItem),
              }}
              onClick={() => handleMenuClick("ingreventory")}
            >
              {isMobile ? "Ingrev" : "Ingreventory"}
            </div>
          </div>
        )}
      </div>

      {/* {user._id && totalRemit.total && totalRemit.total > 0 && (
        <div style={menuStyle.rightSection}>
          <div
            onClick={() => navigate("/billing?tab=2")}
            style={{
              cursor: "pointer",
              fontSize: isMobile ? 10 : 16,
              textAlign: "right",
              marginRight: 35,
            }}
          >
            <span style={{ color: "yellow" }}>
              {isMobile ? "Pay" : "Please Pay"}:{" "}
            </span>
            <NumberFormat
              value={totalRemit.total.toFixed(2)}
              displayType={"text"}
              thousandSeparator={true}
              prefix="₱"
              style={{ fontWeight: "bold", color: "yellow" }}
            />
          </div>
        </div>
      )} */}
    </div>
  );
};

export default Header;
